export enum Operations {
    CanManageGuidedOrdering = 'CanPlaceGuidedOrder'
}
